export const LEAD_WEBHOOK_URL = 'https://hook.us2.make.com/xhdrdc70xmvn8xrbjlecr9ik14pj3rge';

export interface LeadPayload {
  name: string;
  first_name: string;
  phone: string;
  phone_digits: string;
  email: string;
  city: string;
  zip: string;
  service: string;
  description: string;
  photo_count: number;
  photo_names: string;
  source: string;
  page_url: string;
  submitted_at: string;
  submitted_at_local: string;
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_content: string;
  utm_term: string;
  fbclid: string;
}

interface LeadInput {
  name: string;
  phone: string;
  email: string;
  city: string;
  zip: string;
  service: string;
  description: string;
  photoNames: string[];
}

export function buildLeadPayload(input: LeadInput): LeadPayload {
  const params = new URLSearchParams(window.location.search);
  const now = new Date();
  const name = input.name.trim();

  return {
    name,
    first_name: name.split(' ')[0] ?? '',
    phone: input.phone,
    phone_digits: input.phone.replace(/\D/g, ''),
    email: input.email.trim(),
    city: input.city.trim(),
    zip: input.zip.trim(),
    service: input.service || 'Not Sure Yet',
    description: input.description.trim(),
    photo_count: input.photoNames.length,
    photo_names: input.photoNames.join(', '),
    source: 'Website - Free Estimate Form',
    page_url: window.location.href,
    submitted_at: now.toISOString(),
    submitted_at_local: now.toLocaleString('en-US', { timeZone: 'America/New_York' }),
    utm_source: params.get('utm_source') ?? '',
    utm_medium: params.get('utm_medium') ?? '',
    utm_campaign: params.get('utm_campaign') ?? '',
    utm_content: params.get('utm_content') ?? '',
    utm_term: params.get('utm_term') ?? '',
    fbclid: params.get('fbclid') ?? '',
  };
}

export async function sendLead(payload: LeadPayload): Promise<void> {
  const res = await fetch(LEAD_WEBHOOK_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Webhook responded with ${res.status}`);
}
